function animatedClassFunc() {
  const $win = $(window);

  $.fn.animatedClass = (function(options) {
    let defaults = {  
       deviation:500
    };  
        
    var options = $.extend(defaults, options);  
    if (this.length > 0 ) {
      return this.each(function(e) {
        let winScroll = $win.scrollTop(),
          ele = $(this),
          expOff = ele.offset().top - options.deviation,
          timeout,
          delay = 50*(e%5 + 3);

        if (winScroll > expOff) {
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            ele.addClass('animated');
          }, delay);
        }
        else{
          clearTimeout(timeout);
          timeout = setTimeout(function() {
            ele.removeClass('animated');
          }, delay);
        }
      });
    };
  });

  $('.animate').animatedClass({
    deviation: $win.height() - 10
  });

  $win.on('load', function() {
    $('.animate').animatedClass({
      deviation: $win.height() - 10
    });
  })

  $win.scroll(function(){
    $('.animate').animatedClass({
      deviation: $win.height() - 10
    });
  })
}

$(document).on('shopify:section:select', function() {
  $(this).trigger('scroll');
})


export default animatedClassFunc();



// WEBPACK FOOTER //
// ../markup/assets/js/animated-class.js